/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiTransactor {
    SENDER = 'SENDER',
    RECEIVER = 'RECEIVER'
}


export function instanceOfInternalApiTransactor(value: any): boolean {
    for (const key in InternalApiTransactor) {
        if (Object.prototype.hasOwnProperty.call(InternalApiTransactor, key)) {
            if (InternalApiTransactor[key as keyof typeof InternalApiTransactor] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiTransactorFromJSON(json: any): InternalApiTransactor {
    return InternalApiTransactorFromJSONTyped(json, false);
}

export function InternalApiTransactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactor {
    return json as InternalApiTransactor;
}

export function InternalApiTransactorToJSON(value?: InternalApiTransactor | null): any {
    return value as any;
}

export function InternalApiTransactorToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiTransactor {
    return value as InternalApiTransactor;
}

